<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import CMRCommon from './mixin';
import { mapGetters, mapState } from 'vuex';
import { filter, get, orderBy } from 'lodash';
import { CMR_STORAGE_FOR_MEETING_PLAN, planTypes, BASE_PLAN_SUB_TYPES } from '@/common/constants';
import { isZoomMeetingAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';
import { planTypesForMeeting } from '@/views/config/addon-cards/index.vue';
export default {
  mixins: [base, CMRCommon],
  for: ()=> {
      const shouldHide = isZoomMeetingAsAddonCard();
      if(shouldHide) return [];
      return planTypesForMeeting();
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters(['getCurrentBasePlanInfo']),
    lowestPlan() {
      const list = orderBy(
        filter(this.planMapFlat, (p) => p.type === planTypes.CMR),
        ['capacity'],
        'asc',
      );
      return get(list, [0], {});
    },
    desc() {
      const basePlanType = this.getCurrentBasePlanInfo.planType;
      const storage = (
        this.$context.is.edu ?
          CMR_STORAGE_FOR_MEETING_PLAN?.[BASE_PLAN_SUB_TYPES.EDUCATION]
          : CMR_STORAGE_FOR_MEETING_PLAN?.[basePlanType]
      ) ?? 5;
      return this.$t('billing.cmr.desc', [storage]);
    }
  },
  methods: {
    mx_desc() {
      return <div class="opc-addon__description first-capitalize">
        {this.desc}
      </div>;
    },
  }
};
</script>
